<template>
  <div class="route-customization-container">
    <h1 class="page-title">线路定制</h1>
    <el-card class="content-card">
      <div class="card-header">
        <h2>线路定制列表</h2>
        <el-button type="primary" @click="showWechatImgDialog = true">
          <el-icon><upload /></el-icon> 上传联系方式
        </el-button>
      </div>
      <div class="card-content">
        <div class="tab-container">
          <el-tabs v-model="activeTab" @tab-change="handleTabChange">
            <el-tab-pane label="全部" name="all" />
            <el-tab-pane label="已回复" name="replied" />
            <el-tab-pane label="待回复" name="pending" />
          </el-tabs>
        </div>
        <el-table :data="registrations" border stripe style="width: 100%" v-loading="loading">
          <el-table-column label="联系人信息" width="200">
            <template #default="scope">
              <div class="user-info-cell">
                <div>联系人：{{ scope.row.contact_name }}</div>
                <div>电话：{{ scope.row.contact_phone }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="人数信息" width="180">
            <template #default="scope">
              <div class="people-count-cell">
                <div>成人：{{ scope.row.adult_count }}</div>
                <div>儿童：{{ scope.row.child_count }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="服务类型" min-width="150" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.store_names?.join(', ') || '' }}
            </template>
          </el-table-column>
          <el-table-column label="选择设施" min-width="150" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.facility_names?.join(', ') || '' }}
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注" min-width="200" show-overflow-tooltip />
          <el-table-column prop="is_replied" label="是否回复" width="120">
            <template #default="scope">
              <el-tag :type="scope.row.is_replied ? 'success' : 'danger'">
                {{ scope.row.is_replied ? '已回复' : '未回复' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="提交时间" width="180" :formatter="formatDateTime" />
          <el-table-column prop="replied_at" label="回复时间" width="180" :formatter="formatDateTime" />
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <el-button type="primary" size="small" @click="handleReply(scope.row)">
                <el-icon><edit /></el-icon> {{ scope.row.is_replied ? '查看详情' : '回复' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagination-container">
          <el-pagination
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
    
    <!-- 上传微信图片的对话框 -->
    <el-dialog
      v-model="showWechatImgDialog"
      title="上传联系方式图片"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <el-upload
          class="avatar-uploader"
          :action="'/api/upload'"
          :show-file-list="false"
          :on-success="handleWechatImgUploadSuccess"
          :before-upload="beforeWechatImgUpload"
        >
          <img
            v-if="wechatImgUrl"
            :src="wechatImgUrl"
            class="avatar"
          />
          <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
        </el-upload>
        <div style="margin-top: 20px; text-align: center;">
          <el-button type="primary" @click="saveWechatImg">保存</el-button>
          <el-button @click="showWechatImgDialog = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    
    <!-- 回复内容的右侧抽屉 -->
    <el-drawer
      v-model="replyDrawerVisible"
      :title="selectedRegistration.is_replied ? '查看详情' : '添加回复'"
      direction="rtl"
      size="60%"
      :close-on-click-modal="false"
      @close="resetReplyForm"
    >
      <el-form :model="replyForm" :rules="replyRules" ref="replyFormRef" label-width="100px" :label-position="'left'" size="small">
        <div class="compact-form-row">
          <el-form-item label="联系人" prop="contact_name" class="compact-form-item">
            <el-input v-model="replyForm.contact_name" disabled style="width: 180px;" />
          </el-form-item>
          <el-form-item label="联系电话" prop="contact_phone" class="compact-form-item">
            <el-input v-model="replyForm.contact_phone" disabled style="width: 180px;" />
          </el-form-item>
        </div>
        <div class="compact-form-row">
          <el-form-item label="成人数量" prop="adult_count" class="compact-form-item">
            <el-input v-model="replyForm.adult_count" disabled style="width: 100px;" />
          </el-form-item>
          <el-form-item label="儿童数量" prop="child_count" class="compact-form-item">
            <el-input v-model="replyForm.child_count" disabled style="width: 100px;" />
          </el-form-item>
          <el-form-item label="游玩天数" prop="travel_days" class="compact-form-item">
            <el-input v-model="replyForm.travel_days" disabled style="width: 100px;" />
          </el-form-item>
        </div>
        <div class="compact-form-row">
          <el-form-item label="旅行风格" prop="travel_style" class="compact-form-item">
            <el-input :value="replyForm.travel_style === 'special_forces' ? '特种兵' : '舒适游'" disabled style="width: 100px;" />
          </el-form-item>
          <el-form-item label="是否旅拍" prop="need_photo" class="compact-form-item">
            <el-input :value="replyForm.need_photo ? '是' : '否'" disabled style="width: 100px;" />
          </el-form-item>
          <el-form-item label="是否租车" prop="need_car_rental" class="compact-form-item">
            <el-input :value="replyForm.need_car_rental ? '是' : '否'" disabled style="width: 100px;" />
          </el-form-item>
        </div>
        <div class="compact-form-row">
          <el-form-item label="服务类型" prop="store_names" class="compact-form-item full-width">
            <el-input :value="replyForm.store_names.join(', ')" disabled />
          </el-form-item>
        </div>
        <div class="compact-form-row">
          <el-form-item label="选择设施" prop="facility_names" class="compact-form-item full-width">
            <el-input :value="replyForm.facility_names.join(', ')" disabled />
          </el-form-item>
        </div>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="replyForm.remarks" type="textarea" disabled rows="3" />
        </el-form-item>
        <el-form-item label="回复内容" prop="reply_content">
          <div class="editor-container">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editorInstance"
              :default-config="editorConfig"
              :mode="'default'"
              :disabled="selectedRegistration.is_replied"
            />
            <Editor
              v-model="replyForm.reply_content"
              style="height: 300px; overflow-y: auto"
              :default-config="editorConfig"
              :mode="'default'"
              :disabled="selectedRegistration.is_replied"
              @onCreated="handleCreated"
              @onChange="handleChange"
            />
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="drawer-footer">
          <el-button v-if="selectedRegistration.is_replied" @click="replyDrawerVisible = false">关闭</el-button>
          <template v-else>
            <el-button @click="replyDrawerVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmitReply">确定</el-button>
          </template>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import { ref, onMounted, watch, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { Edit, Upload, Plus } from '@element-plus/icons-vue';
import request from '../../api/axios';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import '@wangeditor/editor/dist/css/style.css';

export default {
  name: 'RouteCustomization',
  components: {
    Edit,
    Upload,
    Plus,
    Editor,
    Toolbar
  },
  setup() {
    const registrations = ref([]);
    const loading = ref(false);
    
    const pagination = ref({
      currentPage: 1,
      pageSize: 10,
      total: 0
    });
    
    // Tab相关
    const activeTab = ref('all');
    
    // 回复抽屉相关
    const replyDrawerVisible = ref(false);
    const selectedRegistration = ref({});
    const replyFormRef = ref(null);
    
    const replyForm = ref({
      reply_content: ''
    });
    
    const replyRules = {
      reply_content: [
        { required: true, message: '请输入回复内容', trigger: 'blur' }
      ]
    };
    
    // 富文本编辑器配置
    const editorConfig = {
      placeholder: '请输入回复内容'
    };
    
    // 编辑器实例
    const editorInstance = ref(null);
    
    // 编辑器初始化完成时的回调
    const handleCreated = (editor) => {
      editorInstance.value = editor;
      // 设置初始内容
      editor.setHtml(replyForm.value.reply_content || '<p></p>');
      // 根据is_replied状态禁用编辑器
      if (selectedRegistration.value.is_replied) {
        editor.disable();
      } else {
        editor.enable();
      }
    };
    
    // 编辑器内容变化时的回调
    const handleChange = (editor) => {
      // 如果已回复，则不允许修改内容
      if (!selectedRegistration.value.is_replied) {
        replyForm.value.reply_content = editor.getHtml();
      }
    };
    
    // 监听抽屉打开状态，初始化编辑器内容
    watch(replyDrawerVisible, (visible) => {
      if (visible) {
        nextTick(() => {
          if (editorInstance.value) {
            editorInstance.value.setHtml(replyForm.value.reply_content || '<p></p>');
            // 根据is_replied状态禁用编辑器
            if (selectedRegistration.value.is_replied) {
              editorInstance.value.disable();
            } else {
              editorInstance.value.enable();
            }
          }
        });
      }
    });
    
    // 监听selectedRegistration变化，更新编辑器状态
    watch(() => selectedRegistration.value.is_replied, (isReplied) => {
      if (editorInstance.value) {
        if (isReplied) {
          editorInstance.value.disable();
        } else {
          editorInstance.value.enable();
        }
      }
    });
    
    // 上传微信图片相关
    const showWechatImgDialog = ref(false);
    const wechatImgUrl = ref('');
    
    // 获取线路定制列表
    const fetchRegistrations = async () => {
      loading.value = true;
      try {
        const response = await request({
          url: '/manage/travel-route-registrations',
          method: 'get',
          params: {
            page: pagination.value.currentPage,
            pageSize: pagination.value.pageSize,
            status: activeTab.value === 'all' ? '' : (activeTab.value === 'replied' ? 1 : 0)
          }
        });
        registrations.value = response.data;
        pagination.value.total = response.total;
      } catch (error) {
        ElMessage.error('获取线路定制列表失败');
        console.error(error);
      } finally {
        loading.value = false;
      }
    };
    
    // 处理Tab切换
    const handleTabChange = () => {
      // 重置分页到第一页
      pagination.value.currentPage = 1;
      fetchRegistrations();
    };
    
    // 页面加载时获取列表
    onMounted(() => {
      fetchRegistrations();
    });
    
    // 打开回复抽屉
    const handleReply = (registration) => {
      selectedRegistration.value = registration;
      replyForm.value = {
        contact_name: registration.contact_name,
        contact_phone: registration.contact_phone,
        adult_count: registration.adult_count,
        child_count: registration.child_count,
        travel_days: registration.travel_days,
        travel_style: registration.travel_style,
        need_photo: registration.need_photo,
        need_car_rental: registration.need_car_rental,
        store_names: registration.store_names || [],
        facility_names: registration.facility_names || [],
        remarks: registration.remarks,
        reply_content: registration.reply_content || ''
      };
      replyDrawerVisible.value = true;
    };
    
    // 重置回复表单
    const resetReplyForm = () => {
      replyForm.value = {
        contact_name: '',
        contact_phone: '',
        adult_count: 0,
        child_count: 0,
        travel_days: 0,
        travel_style: '',
        need_photo: false,
        need_car_rental: false,
        store_names: [],
        facility_names: [],
        remarks: '',
        reply_content: ''
      };
      if (replyFormRef.value) {
        replyFormRef.value.resetFields();
      }
    };
    
    // 提交回复
    const handleSubmitReply = async () => {
      if (!replyFormRef.value) return;
      
      await replyFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            await request({
              url: `/manage/travel-route-registrations/${selectedRegistration.value.id}/reply`,
              method: 'put',
              data: {
                reply_content: replyForm.value.reply_content
              }
            });
            ElMessage.success(selectedRegistration.value.is_replied ? '回复更新成功' : '回复成功');
            replyDrawerVisible.value = false;
            fetchRegistrations();
          } catch (error) {
            ElMessage.error(selectedRegistration.value.is_replied ? '回复更新失败' : '回复失败');
            console.error(error);
          }
        } else {
          return false;
        }
      });
    };
    
    // 分页处理
    const handleSizeChange = (size) => {
      pagination.value.pageSize = size;
      fetchRegistrations();
    };
    
    const handleCurrentChange = (current) => {
      pagination.value.currentPage = current;
      fetchRegistrations();
    };
    
    // 处理微信图片上传成功
    const handleWechatImgUploadSuccess = (response) => {
      if (response.code === 200) {
        wechatImgUrl.value = response.data.url;
        ElMessage.success('图片上传成功');
      } else {
        ElMessage.error('图片上传失败');
      }
    };
    
    // 图片上传前验证
    const beforeWechatImgUpload = (file) => {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isJPG) {
        ElMessage.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        ElMessage.error('上传图片大小不能超过 2MB!');
      }
      
      return isJPG && isLt2M;
    };
    
    // 保存微信图片设置
    const saveWechatImg = async () => {
      if (!wechatImgUrl.value) {
        ElMessage.warning('请先上传图片');
        return;
      }
      
      try {
        await request({
          url: '/api/manage/settings',
          method: 'post',
          data: {
            key: 'routes_wechat_img',
            value: wechatImgUrl.value
          }
        });
        ElMessage.success('保存成功');
        showWechatImgDialog.value = false;
      } catch (error) {
        ElMessage.error('保存失败');
        console.error(error);
      }
    };
    
    // 格式化日期时间为 yyyy-MM-dd HH:mm:ss 格式
    const formatDateTime = (_, __, cellValue) => {
      if (!cellValue) return '';
      const date = new Date(cellValue);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    
    return {
      registrations,
      loading,
      pagination,
      activeTab,
      replyDrawerVisible,
      selectedRegistration,
      replyFormRef,
      replyForm,
      replyRules,
      showWechatImgDialog,
      wechatImgUrl,
      fetchRegistrations,
      handleReply,
      resetReplyForm,
      handleSubmitReply,
      handleSizeChange,
      handleCurrentChange,
      handleTabChange,
      handleWechatImgUploadSuccess,
      beforeWechatImgUpload,
      saveWechatImg,
      formatDateTime,
      // 富文本编辑器相关
      editorInstance,
      editorConfig,
      handleCreated,
      handleChange
    };
  }
};
</script>

<style scoped>
.route-customization-container {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.content-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.card-content {
  padding: 0;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 抽屉样式 */
.drawer-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 紧凑表单样式 */
.compact-form-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.compact-form-item {
  margin-bottom: 0;
}

.compact-form-item.full-width {
  flex: 1;
  min-width: 300px;
}

:deep(.el-form-item__label) {
  padding-right: 10px;
  font-weight: 500;
}

:deep(.el-input__wrapper) {
  box-shadow: none;
}

/* 用户信息和人数信息单元格样式 */
:deep(.user-info-cell),
:deep(.people-count-cell) {
  line-height: 1.5;
  font-size: 14px;
}

/* 微信图片上传样式 */
.dialog-content {
  text-align: center;
  padding: 20px 0;
}

/* 编辑器样式 */
.editor-container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.w-e-text-container {
  max-height: 300px;
  overflow-y: auto;
}

.avatar-uploader {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 200px;
  height: 200px;
  display: block;
  object-fit: cover;
  border-radius: 4px;
}
</style>